import { routes, doRequest } from "frontend/api/application";
import {
  HttpMethod,
  HttpPayload,
  UnifiedBaseResponse,
  UnifiedResponse,
} from "frontend/interfaces/http";
import { NoteRaw } from "frontend/interfaces/note";
import { PrimaryKey } from "frontend/interfaces/primary-key";
import { ErrorDatabase } from "frontend/uses/use-errors";

export async function updateNote(
  note: HttpPayload
): Promise<UnifiedResponse<NoteRaw>> {
  const { statusIsSuccess, body } = await doRequest(
    HttpMethod.PATCH,
    routes.paths.frontend_note_path,
    { id: note.id as string },
    note
  );

  return {
    entityRaw: (body as unknown as { note: NoteRaw }).note,
    success: statusIsSuccess,
    errors:
      (body as unknown as { note: { _errors?: ErrorDatabase } }).note._errors ||
      {},
  };
}

export async function createNote(
  note: HttpPayload
): Promise<UnifiedResponse<NoteRaw>> {
  const { statusIsSuccess, body } = await doRequest(
    HttpMethod.POST,
    routes.paths.frontend_notes_path,
    {},
    note
  );

  return {
    entityRaw: (body as unknown as { note: NoteRaw }).note,
    success: statusIsSuccess,
    errors:
      (body as unknown as { note: { _errors?: ErrorDatabase } }).note._errors ||
      {},
  };
}

export async function deleteNote(id: PrimaryKey): Promise<UnifiedBaseResponse> {
  const { statusIsSuccess } = await doRequest(
    HttpMethod.DELETE,
    routes.paths.frontend_note_path,
    { id },
    {}
  );

  return {
    success: statusIsSuccess,
    errors: {},
  };
}
